import React from "react";
import { Output } from "../Text";
import {
  Button,
  ButtonContainer,
  ContentSection,
  PageWrap,
  Heading,
} from "@vwfs-bronson/bronson-react";
import { Analytics } from '../services/analytics';
import { setActualPage, trackInteractionSuccess } from '../pages/page.utils';
import { isVtiBOP } from './JourneyType';

interface VehicleUnavailableProps {
  redirectUrl: string;
  originSystem: string;
}

class VehicleUnavailableError extends React.Component<VehicleUnavailableProps> {
  static defaultProps = {
    redirectUrl: ""
  };

  constructor(props: VehicleUnavailableProps) {
    super(props);

    this.state = {};
  }

  pageName = 'Vehicle unavailable'

  defaultTrackingData = {
    [Analytics.keys.pageName()]: this.pageName,
    [Analytics.keys.viewChange()]: this.pageName,
  }

  trackPage = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.eventType(0)]: 'pageView',
        [Analytics.keys.eventAction(0)]: 'Success',
      }
      Analytics.setTrackingData({...this.defaultTrackingData, ...pageData})
      Analytics.trackPage()
    }, 1000)
  }

  trackButton = () => {
    trackInteractionSuccess('Back to Heycar', this.defaultTrackingData)
  }

  componentDidMount() {
    setActualPage(this.pageName)
    this.trackPage()
  }

  redirect = (target: string) => {
    window.location.assign(target);
    this.trackButton()
  }

  render() {
    return (
      <ContentSection>
        <PageWrap>
          <Heading level="2">
            {Output.resolve(isVtiBOP(this.props.originSystem)
              ? "pages.vehicleUnavailable.vti.title"
              : "pages.vehicleUnavailable.title")
            }
          </Heading>
          {Output.resolveAsMarkdown(isVtiBOP(this.props.originSystem)
                  ? "pages.vehicleUnavailable.vti.subTitle"
                  : "pages.vehicleUnavailable.subTitle")}

          {this.props.redirectUrl && (
            <ButtonContainer center>
              <Button onClick={() => this.redirect(this.props.redirectUrl)}>
                  {Output.resolve("pages.vehicleUnavailable.redirectButtonText")}
                </Button>
            </ButtonContainer>
          )}
        </PageWrap>
      </ContentSection>
    );
  }
}

export { VehicleUnavailableError };
